import { sharePointInternalFileName, sharePointInternalTitleName } from "../../config/constants";
import { FileOption } from "../../interfaces/IFileOption";
import { IFileToUpload } from "../../interfaces/IFileToUpload";
import { SharePointInputData } from "../../interfaces/props/SharePointInputData";
import { titleIsUnset } from "../../helpers/titleMetadata";
import { LocalizationModule } from "../../../../utilities/LocalizationModule";

export const updateIndividualFileOptionsValue = (fileOptions: FileOption[], metadata: SharePointInputData[], changedIndex: number, titleAutoSetText: string) => {

    const changedInput = metadata.find(x => x.index === changedIndex);

    return fileOptions.map(fileOption => {
        return {
            ...fileOption,
            fileInputValues: fileOption.fileInputValues.map((inputValue, index) => {
                if (inputValue.internalName === changedInput?.internalName && !(inputValue.internalName === sharePointInternalTitleName && changedInput?.value === titleAutoSetText)) {
                    return { ...changedInput }
                }

                return { ...inputValue }

            })
        }
    });
}

export const updateFileName = (fileOptions: FileOption[], updatedFile: IFileToUpload) => {
    const titleAutoSetVariants = LocalizationModule.getTitleAutoSetVariants();
    // Update only the renamed file's option, matched by id (FileOption.key === file.id).
    // Fall back to the legacy "apply to all" behaviour when the id is missing or
    // matches no option, so a rename is never silently dropped.
    const matchById = !!updatedFile?.id && fileOptions.some(fileOption => fileOption.key === updatedFile.id);
    return fileOptions.map(fileOption => {
        if (updatedFile && (!matchById || fileOption.key === updatedFile.id)) {
            const previousName = fileOption.fileInputValues.find(x => x.internalName === sharePointInternalFileName)?.value;
            return {
                ...fileOption,
                updatedFile,
                text: updatedFile.name,
                fileInputValues: fileOption.fileInputValues.map(inputValue => {
                    if (inputValue.internalName === sharePointInternalFileName) {
                        return { ...inputValue, value: updatedFile.name };
                    }

                    // Mirror the Title to the new name while it is still tracking it
                    // (unset or equal to the prior name); a user-typed Title is kept.
                    if (inputValue.internalName === sharePointInternalTitleName
                        && (titleIsUnset(inputValue.value, titleAutoSetVariants) || inputValue.value === previousName)
                        && updatedFile.name
                        && inputValue.value !== updatedFile.name) {
                        return { ...inputValue, value: updatedFile.name, hasError: false };
                    }

                    return {
                        ...inputValue,
                        value: inputValue.value
                    }
                })
            }
        }

        return {
            ...fileOption
        }
    })
}

export const fileCheckedToggled = (fileOptions: FileOption[], toggledFile: IFileToUpload, canOverwrite: boolean, inputValuesToSave: SharePointInputData[]) => {
    let updatedFileOptions: FileOption[] = [];
    const fileOption = fileOptions.find(x => x.key === toggledFile.id);
    if (toggledFile.isSelected) {
        if (!fileOption) {
            const newFileOption = {
                key: toggledFile.id,
                text: toggledFile.name,
                file: toggledFile,
                isSelectedFile: false,
                isModified: false,
                canOverwrite,
                isSaving: false,
                savingSuccess: false,
                savingError: false,
                fileInputValues: fileOptions[0].fileInputValues.map(inputValue => {
                    let originalInputValue = inputValuesToSave.find(x => x.internalName === inputValue.internalName)
                    let value;

                    if (inputValue.internalName === sharePointInternalFileName || inputValue.internalName === sharePointInternalTitleName) {
                        value = toggledFile.name;
                    } else {
                        value = originalInputValue?.value
                    }

                    if (originalInputValue) {
                        return {
                            ...originalInputValue,
                            value
                        }
                    }

                    return {
                        ...inputValue,
                        value
                    }

                }),
            }

            updatedFileOptions = [...fileOptions];
            updatedFileOptions.push(newFileOption);
        }
    }
    else {
        updatedFileOptions = fileOptions.filter(x => x.key !== toggledFile.id).map(fileOption => {
            return {
                ...fileOption
            }
        });
    }

    return updatedFileOptions;
}